import React, { useState } from 'react';
import './CSS/ContactUs.css';
import { servicesData } from '../Helpers/ServicesHelper';
import axios from 'axios';
import { CUSTOMER_ADDRESS_EMAIL_TEMPLATE, CUSTOMER_ADMIN_EMAIL_TEMPLATE, CUSTOMER_WITHOUT_ADDRESS_EMAIL_TEMPLATE } from '../Helpers/EmailTemplateHelder';

const ContactUs = () => {
  const [selectedService, setSelectedService] = useState('home-pickup');
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    service: '',
    deviceType: '',
    deviceName: '',
    pickupAddress: '',
    postCode: '',             // <-- NEW
    pickupTime: '',
    pickupDate: '',
    issueDescription: ''
  });

  const [responseMessage, setResponseMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setFormData({ ...formData, service, postCode: service === 'drop-off' ? '' : formData.postCode });
    setResponseMessage('');
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (e.target.name === 'postCode') {
      // Live reset of area message when postcode changes
      setResponseMessage('');
    }
  };

  const isServedPostcode = (pc) => {
    if (!pc) return false;
    // Normalize: remove spaces, uppercase
    const norm = pc.replace(/\s+/g, '').toUpperCase();
    return norm.startsWith('W11'); // accept W11, W11 2AA, etc.
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Area check for home pickup
    if (selectedService === 'home-pickup' && !isServedPostcode(formData.postCode)) {
      setResponseMessage('pickup is not available in your area.');
      return;
    }

    setLoading(true);

    const type = selectedService === 'drop-off' ? 'Drop-off' : 'Pickup';
    const payloadForTemplates = {
      ...formData,
      type,
      pickupAddress: selectedService === 'drop-off' ? '' : formData.pickupAddress,
      postCode: selectedService === 'drop-off' ? '' : formData.postCode
    };

    const data = {
      sender_email: 'info@fixinn.com',
      receiver_email: formData.email,
      subject: 'Thank you for booking a service with Fixinn',
      domain: 'fixinn',
      html_body:
        selectedService === 'drop-off'
          ? CUSTOMER_WITHOUT_ADDRESS_EMAIL_TEMPLATE(payloadForTemplates)
          : CUSTOMER_ADDRESS_EMAIL_TEMPLATE(payloadForTemplates)
    };

    const dataAdmin = {
      sender_email: formData.email,
      receiver_email: 'info@fixinn.com',
      subject: 'New Service Request',
      domain: 'fixinn',
      html_body: CUSTOMER_ADMIN_EMAIL_TEMPLATE(payloadForTemplates)
    };

    try {
      const responseAdmin = await axios.post(
        'https://m52vkpoo46edzgvw3bkscwsfgq0xrxsm.lambda-url.us-east-1.on.aws',
        dataAdmin
      );
      if (responseAdmin.data.message === 'Email sent successfully.') {
        const response = await axios.post(
          'https://m52vkpoo46edzgvw3bkscwsfgq0xrxsm.lambda-url.us-east-1.on.aws',
          data
        );
        setResponseMessage(response.data.message || 'Service booked successfully!');
      }
    } catch (error) {
      setResponseMessage(error.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }

    setTimeout(() => {
      setResponseMessage('');
    }, 5000);
  };

  return (
    <section className="contact-us-section">
      <div className="container">
        <div className="contact-us-content">
          {/* Left Column */}
          <div className="contact-us-left">
            <div className="contact-us-header">
              <h2 className="contact-us-title" style={{ minHeight: '60px' }}>
                How Would You Like to <span className="text-primary">Send Us Your Device?</span>
              </h2>
              <p className="contact-us-description">
                Choose the option that suits you best — either we pick it up from your home,
                or you drop it off at our shop. Easy, flexible, and hassle-free!
              </p>
            </div>

            <div className="service-options">
              <div
                className={`service-option ${selectedService === 'home-pickup' ? 'selected' : ''}`}
                onClick={() => handleServiceSelect('home-pickup')}
              >
                <div className="service-icon">
                  <img src={require('../assets/icons/service1.png')} alt="Home Pickup Icon" style={{ width: 60 }} />
                </div>
                <div className="service-content">
                  <h3>Home Pickup Service</h3>
                  <p>We collect your device from your doorstep — fast, safe, and convenient.</p>
                </div>
                <div className="service-checkbox">
                  {selectedService === 'home-pickup' && (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                      <circle cx="12" cy="12" r="10" fill="white" />
                      <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="3"
                        strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </div>
              </div>

              <div
                className={`service-option ${selectedService === 'drop-off' ? 'selected' : ''}`}
                onClick={() => handleServiceSelect('drop-off')}
              >
                <div className="service-icon">
                  <img src={require('../assets/icons/service2.png')} alt="Drop-off Icon" style={{ width: 60 }} />
                </div>
                <div className="service-content">
                  <h3>Drop-off at Our Shop</h3>
                  <p>Visit us to drop off your device and get immediate assistance.</p>
                </div>
                <div className="service-checkbox">
                  {selectedService === 'drop-off' && (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                      <circle cx="12" cy="12" r="10" fill="white" />
                      <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="3"
                        strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </div>
              </div>
            </div>

            <div className="contact-info">
              <h3>Speak Directly with Our Team</h3>
              <p>Need assistance or want to book your service over the phone? Give us a call, and we'll take care of everything for you.</p>

              <div className="contact-methods">
                <a href="tel:07946203616" className="contact-method">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M22 16.92V19.92C22 20.52 21.52 21 20.92 21C10.93 21 3 13.07 3 3.08C3 2.48 3.48 2 4.08 2H7.08C7.68 2 8.16 2.48 8.16 3.08V6.08C8.16 6.68 7.68 7.16 7.08 7.16H5.08C5.08 8.16 6.92 15.84 7.92 16.84H16.84C16.84 16.32 17.32 15.84 17.92 15.84H20.92C21.52 15.84 22 16.32 22 16.92Z" stroke="currentColor" strokeWidth="2" fill="none" />
                  </svg>
                  07946203616
                </a>

                <a href="mailto:support@fixinn.co.uk" className="contact-method">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect width="20" height="16" x="2" y="4" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
                    <path d="m22 7-10 5L2 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                  support@fixinn.co.uk
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="contact-us-right">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row1">
                <div className="form-group full-width">
                  <label htmlFor="fullName">Full Name</label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    placeholder="Enter your full name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row1">
                <div className="form-group full-width">
                  <label htmlFor="service">Select Service</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select</option>
                    {Object.keys(servicesData).map((key) => {
                      const service = servicesData[key];
                      return (
                        <option key={key} value={service.title}>
                          {service.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="deviceType">Device Type</label>
                  <input
                    type="text"
                    id="deviceType"
                    name="deviceType"
                    placeholder="Device Type"
                    value={formData.deviceType}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="deviceName">Brand & Model</label>
                  <input
                    type="text"
                    id="deviceName"
                    name="deviceName"
                    placeholder="Enter your device name"
                    value={formData.deviceName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              {selectedService === 'home-pickup' && (
                <>
                  {/* Address + Postcode on the same row */}
                  <div className="form-row">
                    <div className="form-group" style={{ flex: 2 }}>
                      <label htmlFor="pickupAddress">Pickup Address</label>
                      <input
                        type="text"
                        id="pickupAddress"
                        name="pickupAddress"
                        placeholder="Enter your address"
                        value={formData.pickupAddress}
                        onChange={handleInputChange}
                        required={selectedService === 'home-pickup'}
                      />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                      <label htmlFor="postCode">Postcode</label>
                      <input
                        type="text"
                        id="postCode"
                        name="postCode"
                        placeholder="e.g., W11 2AA"
                        value={formData.postCode}
                        onChange={handleInputChange}
                        required={selectedService === 'home-pickup'}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="pickupDate">Preferred Pickup Date</label>
                  <input
                    type="date"
                    id="pickupDate"
                    name="pickupDate"
                    value={formData.pickupDate}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="pickupTime">Preferred Pickup Time</label>
                  <input
                    type="time"
                    id="pickupTime"
                    name="pickupTime"
                    value={formData.pickupTime}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row1">
                <div className="form-group full-width">
                  <label htmlFor="issueDescription">Issue Description</label>
                  <textarea
                    id="issueDescription"
                    name="issueDescription"
                    placeholder="Enter your message"
                    rows="4"
                    value={formData.issueDescription}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>
              </div>

              {/* Response Message */}
              {responseMessage && (
                <div style={{ color: '#B30F29', marginTop: '10px', fontWeight: 'bold' }}>
                  {responseMessage}
                </div>
              )}

              <div className="form-row1" style={{ marginTop: '20px' }}>
                <div className="form-group full-width">
                  {loading ? (
                    <p>Sending email...</p>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={
                        loading ||
                        (selectedService === 'home-pickup' &&
                          formData.postCode &&
                          !isServedPostcode(formData.postCode))
                      }
                    >
                      Book a Service
                    </button>
                  )}
                </div>
              </div>

              {/* Optional inline postcode hint for UX */}
              {selectedService === 'home-pickup' && formData.postCode && !isServedPostcode(formData.postCode) && (
                <p style={{ marginTop: 8, color: '#B30F29' }}>
                  Pickup is not available in your area.
                </p>
              )}

            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
